import { all, put, take, select, actionChannel } from 'redux-saga/effects';
import { GET_ANNOTATIONS, SET_IFRAME_ATTRIBUTES, GET_PAGE_BREAKS } from './actions';
import { SAVE_TITLE, SAVE_PAGE_BREAKS } from 'reducers/dataModels';
import { SAVE_BOOK_PAGE_BREAK } from 'reducers/compModels';
import { getChapter, getChapters } from 'lib/getChapter';
import getPage from 'lib/getPage';

function* setIframeTitle() {
  const chan = yield actionChannel(SAVE_BOOK_PAGE_BREAK);
  yield all([
    take(SAVE_TITLE),
    // take(SAVE_TOC),
    take(SAVE_PAGE_BREAKS),
  ]);
  const { toc, title, pageBreaks } = yield select();
  const chapters = getChapters(toc);
  while(true) {
    const { data: pageLabel } = yield take(chan);
    console.time('setIframeTitle#setIframeTitle')
    if (pageLabel) {
      const page = getPage(pageBreaks.pages, pageLabel);
      if (page) {
        const chapter = getChapter(chapters, page);
        const iframeTitle = (chapter ? `${title} | ${chapter.title}` : title);
        const iframe = document.getElementsByTagName('iframe')[0];
        iframe.setAttribute('title', iframeTitle);
      }
    }
    console.timeEnd('setIframeTitle#setIframeTitle')
  }
}


function* setIframeAttributes() {
  yield take(SET_IFRAME_ATTRIBUTES);
  console.time('setIframeAttributes#setIframeAttributes')
  const iframe = document.getElementsByTagName('iframe')[0];
  iframe.setAttribute('allow', 'fullscreen');
  iframe.setAttribute('allowfullscreen', true);
  iframe.setAttribute('webkitallowfullscreen', true);
  iframe.setAttribute('mozallowfullscreen', true);
  iframe.setAttribute('title', 'Ereader');
  iframe.setAttribute('data-test-id', 'container-frame');
  // Attempted fix for LST-1778. Not successful but leaving here for future reference
  // iframe.setAttribute('allow', 'clipboard-write');

  yield all([
  	put({ type: GET_ANNOTATIONS }),
  	put({ type: GET_PAGE_BREAKS }),
  ]);
  console.timeEnd('setIframeAttributes#setIframeAttributes')
}

export default function* rootSaga() {
  yield all([
    setIframeAttributes(),
    setIframeTitle(),
  ]);
}
